import type { PackageKeys } from './package.type';

export enum FeatureType {
  CHAT_WINDOW_FONT = 'CUSTOM_CHAT_FONT',
  CHAT_AVATAR_TYPE = 'CHAT_AVATAR_TYPE',
  HOT_TOPICS = 'HOT_TOPICS',
  LEADS_INTERESTED_CARD = 'LEADS_INTERESTED_CARD',
  RESEARCH_QUESTIONS_CARD = 'RESEARCH_QUESTIONS_CARD',
  WORKFLOW_AUTOMATED_CARD = 'WORKFLOW_AUTOMATED_CARD',
  HANDOVER_TO_HUMAN_CARD = 'HANDOVER_TO_HUMAN_CARD',
  USER_ENGAGEMENT = 'USER_ENGAGEMENT',
  SLASH_COMMAND_TEMPLATES = 'SLASH_COMMAND_TEMPLATES',
  TICKET_DEFLECTION_CARD = 'TICKET_DEFLECTION_CARD',
}

export interface FeatureAutoConfigChanges {
  onUpgrade?: {
    [where: string]: {
      [field: string]: any;
    };
  };
  onDowngrade?: {
    [where: string]: {
      [field: string]: any;
    };
  };
}

export interface FeatureDefinition {
  id: FeatureType; // Unique identifier for the feature
  availableInPackages: PackageKeys[]; // Packages that include this feature
  isPackageGated: boolean; // Whether the feature is restricted by package
  allowAdminOverride?: boolean; // Whether admins can enable this feature regardless of package
  autoConfigChanges?: FeatureAutoConfigChanges; // Automatic config changes on package change ( downgrade or upgrade )
}
